
import React, { useState, useRef, useEffect } from 'react';
import './MessagesPage.css';
import { useApp } from '../../context/AppContext';

const MessagesPage: React.FC = () => {
  const { messages, adminUser, currentUser, sendMessage } = useApp();
  const [input, setInput] = useState('');
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const chatMessages = messages.sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime());

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatMessages]);

  const handleSend = () => {
    if (input.trim()) {
      sendMessage(input.trim());
      setInput('');
    }
  };

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="messages-page">
      <div className="chat-header-info">
        <img src={adminUser.avatar} alt={adminUser.displayName} className="chat-avatar" />
        <div className="chat-info">
          <h3>
            {adminUser.displayName}
            <svg className="verified" viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          </h3>
          <span className="online-status">Online now</span>
        </div>
      </div>

      <div className="messages-list">
        {chatMessages.map(msg => (
          <div 
            key={msg.id} 
            className={`message ${msg.fromUserId === currentUser.id ? 'sent' : 'received'}`}
          >
            {msg.fromUserId !== currentUser.id && (
              <img src={adminUser.avatar} alt="" className="msg-avatar" />
            )}
            <div className="message-bubble">
              <p>{msg.content}</p>
              <span className="message-time">{formatTime(msg.timestamp)}</span>
            </div>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      <div className="message-input-area">
        <button className="attachment-btn">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21 15 16 10 5 21"/>
          </svg>
        </button>
        <input
          type="text"
          placeholder="Type a message..."
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyPress={e => e.key === 'Enter' && handleSend()}
        />
        <button className="send-btn" onClick={handleSend} disabled={!input.trim()}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default MessagesPage;
